module.exports = __webpack_public_path__ + "img/0860-plus-circle.5e8b2ee2.svg";